import { Button, Modal } from 'react-bootstrap';

const ConfirmationModal = ({ action, show, onClose, onSave }) => {

    return (
        <Modal
            show={show}
            onHide={onClose}
            onClose={onClose}
            backdrop="static"
            keyboard={true}

        >
            <Modal.Header >
                <Modal.Title>Confirm Submission</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure, you want to Save! This will not be available for PHMC to review. </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}> Close </Button>
                <Button variant="primary" name={action} onClick={onSave}>Proceed</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;
